import React from 'react';
import { motion } from 'framer-motion';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Sani Roy',
      designation: 'Director',
      company: 'Indian Suraksha Force',
      review: 'Thank you Wevatar, for you we got to take our business digitally and connect with border region.'
    },
    {
      name: 'Aparna Roy',
      designation: 'Director',
      company: 'Swami Dhananjoydas Kathia Baba Mission School, Silchar',
      review: 'We did not have any website, Wevatar helped us to first get digital appearance with Wevatar.'
    },
    {
      name: 'Arun Das',
      designation: 'Managing Director',
      company: 'Terve Lifesciences',
      review: 'For our products, Wevatar designed and gave us a digital identity for our business.'
    },
    {
      name: 'Nikhil Das',
      designation: 'Owner',
      company: 'Barak Bani Dainik',
      review: 'Wevatar has helped taking our news publications to a broader audience with great design and e-paper CMS at an affordable price.'
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="testimonials">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        What Our Clients Say
      </motion.h2>
      <div className="testimonials-slider" aria-label="Client testimonials">
        <div className="testimonials-track">
        {[...testimonials, ...testimonials].map((testimonial, index) => (
          <motion.div
            key={index}
            className="testimonial-card"
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="testimonial-mark">“</div>
            <p>{testimonial.review}</p>
            <div className="client-info">
              <strong>{testimonial.name}</strong>
              <span>{testimonial.designation}</span>
              <small>{testimonial.company}</small>
            </div>
          </motion.div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
